export const QA_NAME_DOC_FLOW_CREATION_MODAL = 'create_doc_flow'
